module.exports = __webpack_public_path__ + "static/york_laptop_mobile-3005d2c0ed411e5b412383e04e976637.png";